import {
  API_SUITABILITYINFO_URL,
  replacePlaceholders,
} from './urls';
import callWebApi from './callWebApi';
import {
  createFetchActionCreator,
} from './index';

import { toViewModel, toDto } from '../helpers/mappings/suitabilityMappings';

const handlePartialUpdate = (suitabilityInformationCurrent, suitabilityInformationUpdated, partialName) => {
  const suitabilityInfo = { ...suitabilityInformationCurrent };
  switch (partialName) {
    case 'financialSituation':
      suitabilityInfo.financialSituation = { ...suitabilityInformationUpdated.financialSituation };
      break;
    case 'investmentRiskTolerance':
      suitabilityInfo.investmentRiskTolerance = { ...suitabilityInformationUpdated.investmentRiskTolerance };
      break;
    case 'financialInvestment':
      suitabilityInfo.investmentExperience = { ...suitabilityInformationUpdated.investmentExperience };
      break;
    case 'investmentObjectives':
      suitabilityInfo.investmentObjectives = { ...suitabilityInformationUpdated.investmentObjectives };
      break;
    default:
      break;
  }
  return suitabilityInfo;
};
export const updateSuitabilityInfo = (updates, isPartial, partialName) => async (dispatch, getState) => {
  const { user, authToken, suitabilityInformation } = getState();
  dispatch({ type: 'SUITABILITY_INFO_UPDATE/REQUESTED' });
  let updatedModel = updates;
  if (isPartial) {
    updatedModel = handlePartialUpdate(suitabilityInformation.data, updatedModel, partialName);
  }
  updatedModel = toDto(updatedModel);
  const suitabilityInfo = { data: updatedModel };
  const url = replacePlaceholders(API_SUITABILITYINFO_URL, { suitabilityInfoId: user.data.suitabilityInformationId });
  await callWebApi('PATCH', url, suitabilityInfo, authToken);
  dispatch({ type: 'SUITABILITY_INFO_UPDATE/SUCCEED' });
};

export const fetchSuitabilityInfo = createFetchActionCreator(state => replacePlaceholders(API_SUITABILITYINFO_URL, { suitabilityInfoId: state.user.data.suitabilityInformationId }), 'suitabilityInformation', {}, { force: true, transformData: toViewModel });



// WEBPACK FOOTER //
// ./src/actions/suitability.js